<div class="alert alert-danger" role="alert" [hidden]="hideError">
  <div
      class="d-inline-flex align-items-center justify-content-center p-4 me-3 fs-4 flex-shrink-0 rounded-circle obrame-login-icon-bg">
      <fa-icon [icon]="faTriangleExclamation"></fa-icon>
  </div>
  {{errorMessage}}
</div>